export default __webpack_public_path__ + "static/media/cambridge-exams-learn-english.8ec13c7e.webp";